// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"slideshow-module--wrapper--2oHjU","image":"slideshow-module--image--2D7iv"};